import { Routes } from "@angular/router";
import { ApplicationUserTypeId } from "src/app/core";

export const usersListRoutes: Routes = [
  {
    path: "",
    title: "USERS.TITLE",
    loadComponent: () => import("./pages/users-list/users-list.component").then((m) => m.UsersListComponent),
  },
  {
    path: "visitors",
    title: "USERS.TITLE",
    loadComponent: () => import("./pages/users-list/users-list.component").then((m) => m.UsersListComponent),
  },
  {
    path: "memberships",
    title: "USERS.TITLE",
    loadComponent: () => import("./pages/users-list/users-list.component").then((m) => m.UsersListComponent),
  },
  // {
  //   path: "organized-schools",
  //   title: "USERS.TITLE",
  //   loadComponent: () => import("./pages/users-list/users-list.component").then((m) => m.UsersListComponent),
  // },
];

export const usersRoutes: Routes = [
  {
    path: "edit/:id",
    title: "USERS.EDIT",
    loadComponent: () => import("./pages/add-edit-user/add-edit-user.component").then((m) => m.AddEditUserComponent),
  },
  {
    path: "add",
    title: "USERS.ADD",
    data: { userType: ApplicationUserTypeId.Client },
    loadComponent: () => import("./pages/add-edit-user/add-edit-user.component").then((m) => m.AddEditUserComponent),
  },
  {
    path: "add-system-user",
    title: "USERS.ADD",
    data: { userType: ApplicationUserTypeId.User },
    loadComponent: () => import("./pages/add-edit-user/add-edit-user.component").then((m) => m.AddEditUserComponent),
  },
];
